var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSliderhandle2 = function SvgFadSliderhandle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.17 48.542a8.001 8.001 0 0 0-8.004 8.004v143.736a8 8 0 0 0 8.003 8.004h144.554c4.42 0 8.004-3.58 8.004-8.004V56.546a8 8 0 0 0-8.004-8.004H55.17z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.788 192.4V64.227h128.486l-7.901 16.31.393 99.692a3.983 3.983 0 0 1-3.976 4.001H81.328l-17.54 8.168z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.995 112A3.995 3.995 0 0 0 89 115.996v8.008a3.974 3.974 0 0 0 3.998 3.976l71.534-.365c2.208-.011 4.052-1.81 4.118-4.016l.23-7.603a3.85 3.85 0 0 0-3.875-3.996h-72.01z",
    fill: "#000"
  }))));
};
export { SvgFadSliderhandle2 as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-sliderhandle-2.e8ee2aae.svg";